module.exports = __webpack_public_path__ + "img/php-list.png";